import produce from 'immer';

import * as alertUserRoutines from '../../Containers/AlertUser/routines';
import * as channelsRoutines from './channelRoutines';
import * as userRoutines from '../../sagas/routines/userRoutines';
const initialState = {
    avatars: {},
    distinct_users: [],
    firebase: [],
    groups: {},
    users_loading: false,
};

export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
        case userRoutines.loadingUsers.TRIGGER:
            return produce(state, draft => {
                draft.users_loading = action.payload;
            });
        case userRoutines.makeDistinctUsersFromCombined.TRIGGER:
            return produce(state, draft => {
                draft.distinct_users = [];
            });
        case userRoutines.makeDistinctUsersFromCombined.SUCCESS:
            return produce(state, draft => {
                draft.distinct_users = action.payload;
            });

        case userRoutines.clearExtractedUsers.TRIGGER:
            return produce(state, draft => {
                draft.distinct_users = [];
                draft.groups = {};
            });

        case channelsRoutines.fetchUsersBatchFromGroup.SUCCESS:
            const { users } = action.payload;
            let optimized = users.map(user => {
                //TODO clean up the following logic!
                let firstName =
                    user.relationships &&
                    user.relationships.userNames &&
                    user.relationships.userNames[0] &&
                    user.relationships.userNames[0].attributes &&
                    user.relationships.userNames[0].attributes.firstName
                        ? user.relationships.userNames[0].attributes.firstName
                        : '';
                let lastName =
                    user.relationships &&
                    user.relationships.userNames &&
                    user.relationships.userNames[0] &&
                    user.relationships.userNames[0].attributes &&
                    user.relationships.userNames[0].attributes.lastName
                        ? user.relationships.userNames[0].attributes.lastName
                        : '';
                return {
                    firstName,
                    id: user.id,
                    lastName,
                };
            });
            return produce(state, draft => {
                let prev = state.groups[action.payload.groupId] ? state.groups[action.payload.groupId] : [];
                draft.groups[action.payload.groupId] = [...prev, ...optimized];
            });
        case userRoutines.syncUsers.SUCCESS:
            return {
                ...state,
                firebase: action.payload,
            };
        case userRoutines.fetchUserAvatar.SUCCESS:
            return produce(state, draft => {
                draft.avatars[action.payload.id] = action.payload.avatar;
            });

        case alertUserRoutines.fetchAlertUser.SUCCESS: //For bootstrapping
            return produce(state, draft => {
                draft.avatars['AlertUser'] = action.payload.profileImageThumbnail;
            });
        case alertUserRoutines.saveAlertUserImage.SUCCESS: //For setting or updating profile picture
            return produce(state, draft => {
                draft.avatars['AlertUser'] = action.payload.downloadablePath120;
            });
        default:
            return state;
    }
}
